<template>
  <el-container style="width:100%;">
    <el-header>
      <el-row type="flex" align="middle">
        <el-col :span="6" style="padding-top: 10px;">
          <el-button round @click="onRefersh">刷新</el-button>
        </el-col>
      </el-row>
    </el-header>
    <el-main>
      <el-table :data="levels" tooltip-effect="dark" style="width: 100%; margin-bottom:60px;" v-loading.body="fetchLevelsLoading">
        <el-table-column prop="level" label="等级" width="140">
        </el-table-column>
        <el-table-column prop="name" label="名称">
        </el-table-column>
        <el-table-column label="操作" width="100">
          <template slot-scope="scope">
            <el-button @click="onEdit(scope.row.level)" type="text" size="small">编辑</el-button>
          </template>
        </el-table-column>
      </el-table>
    </el-main>
    <el-dialog title="编辑等级名称" :visible.sync="editDialogVisiable" :append-to-body="true">
      <el-form ref="form" :model="form" :rules="rules" label-width="100px" class="detailForm">
        <el-form-item label="等级名称" prop="name">
          <el-input v-model="form.name"></el-input>
        </el-form-item>
        <div style="text-align: center;">
          <el-button type="primary" @click="onConfirmEditName">保存</el-button>
          <el-button @click="onCancel">取消</el-button>
        </div>
      </el-form>
    </el-dialog>
  </el-container>
</template>

<script>
import { generateCustomizeString } from '@/utils/i18n'
import request from '@/utils/request'

export default {
  name: 'LevelList',
  data() {
    return {
      levels: [],
      fetchLevelsLoading: false,
      rules: {
        name: [
          {
            required: true,
            min: 2,
            max: 64,
            message: '请输入最少2个字符的等级名',
            trigger: 'blur'
          }
        ]
      },
      form: {
        name: ''
      },
      currentEditLevel: null,
      fetchUpdateLevelNameLoading: false,
      editDialogVisiable: false
    }
  },
  created() {
    this.fetchLevels()
  },
  methods: {
    generateCustomizeString,
    onRefersh() {
      this.fetchLevels()
    },
    onEdit(level) {
      this.currentEditLevel = level
      this.editDialogVisiable = true
    },
    onCancel() {
      this.$refs.form.resetFields()
      this.editDialogVisiable = false
    },
    onConfirmEditName() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.fetchUpdateLevelName(this.currentEditLevel, this.form)
        } else {
          this.$message.error('数据错误')
        }
      })
    },
    fetchUpdateLevelName(level, data) {
      if (this.fetchUpdateLevelNameLoading) return
      this.fetchUpdateLevelNameLoading = true
      request({
        url: `discount/level/${level}`,
        method: 'patch',
        data
      }).then(response => {
        this.fetchLevels()
        this.currentEditLevel = null
        this.editDialogVisiable = false
        this.fetchUpdateLevelNameLoading = false
      }).catch(error => {
        console.warn(error)
        this.fetchUpdateLevelNameLoading = false
      })
    },
    fetchLevels() {
      if (this.fetchLevelsLoading) return
      this.fetchLevelsLoading = true
      request({
        url: 'discount/level/list',
        method: 'get'
      }).then(response => {
        this.levels = response.data
        this.fetchLevelsLoading = false
      }).catch(error => {
        console.warn(error)
        this.fetchLevelsLoading = false
      })
    }
  }
}
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
  .el-header,
  .el-footer {
    background-color: #f6f6f6;
    color: #333;
  }
</style>
<style type="text/css">
  .el-dialog {
    width: 40%;
  }
  @media only screen and (max-width: 576px) {
    .el-dialog {
      width: 90%;
    }
  }
</style>
